// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1cw1l","infoBtn":"quickbooks_infoBtn__2HP3F","formBox":"quickbooks_formBox__G3wjj","formFooter":"quickbooks_formFooter__21p_p"};